import XpcPlugin from './xpc';
import LookupPlugin from './lookup';
import PicklistPlugin from './picklist';
import AddressPlugin from './address';
import LocalePlugin from './locale';
import DealThousandsPlugin from './dealThousands';
import VariablesPlugin from './variables';

import ErrorHandlerPlugin from './errorHandler';
import BoundaryAccessPlugin from './boundaryAccess';
import HttpCancelPlugin from './httpCancel';
import AppendToBodyPlugin from './appendToBody';

/**
 * 默认加载插件项
 */
export const defaultPlugins = [
  XpcPlugin,
  AddressPlugin,
  DealThousandsPlugin,
  LocalePlugin,
  LookupPlugin,
  PicklistPlugin,
  VariablesPlugin
];

/**
 * 可选加载插件项
 */
export const optionalPlugins = [
  // 边界访问控制
  BoundaryAccessPlugin,
  // 全局错误处理
  ErrorHandlerPlugin,
  // http请求边界处理
  HttpCancelPlugin,
  // ElementUI弹出式组件默认添加到body
  AppendToBodyPlugin
];



// WEBPACK FOOTER //
// ./~/vue-xpc/src/plugins/index.js